import React from "react";
import BaseMessage from "./BaseMessage";

export default function Warning(props) {
    return <BaseMessage {...props} type={"warning"} />
}